import { createSlice } from '@reduxjs/toolkit';

import { TeamInitialState, TeamTypes } from 'store/team/team.state.ts';

const initialState: TeamTypes = TeamInitialState;

export const teamSlice = createSlice({
  name: 'team',
  initialState,
  reducers: {
    setSelectedTeamState: (state, action) => {
      state.entities = action.payload;
    },
    // The selected team carries its roster (personnel, equipment). `logout()`
    // dropped it by clearing the persist root and reloading; a session that
    // ends without a reload needs this to avoid handing one user's team to the
    // next user of a shared device.
    resetTeam: () => initialState,
  },
});

export default teamSlice.reducer;
